import { Tween } from "slotworks/utils/tween";
import Timer from "../timer";
import Contract from "./contract";
import Parallel from "./parallel";
import Sequence from "./sequence";

export type Cancellable = Contract<any> | Tween | number;

export default class CancelGroup {

    private group: Cancellable[] = [];

    public parallel<T>(methods: Array<() => Contract<T>>): Parallel<T> {
        return this.add(new Parallel(methods));
    }

    public sequence<T>(methods: Array<() => Contract<T>>): Sequence<T> {
        return this.add(new Sequence(methods));
    }

    public contract<T>(method: (resolve: (value?: T) => void) => void): Contract<T> {
        return this.add(new Contract<T>(method));
    }

    public timeout<T>(callback: () => T, duration: number): number {
        return this.add(Timer.setTimeout(callback, duration));
    }

    public interval<T>(callback: () => T, duration: number): number {
        return this.add(Timer.setInterval(callback, duration));
    }

    public tween(object: any): Tween {
        return this.add(new Tween(object)) as Tween;
    }

    public add<T extends Cancellable>(item: T): T {
        this.group.push(item);
        return item;
    }

    /**
     * Cancel all in group
     * @returns {boolean} true if anything was cancelled
     */
    public cancel(): boolean {
        const cancelled: boolean = this.group.length > 0;
        while (this.group.length) {
            const cancellable: Cancellable = this.group.shift();
            if (cancellable instanceof Tween) {
                cancellable.stop();
            } else if (cancellable instanceof Contract) {
                cancellable.cancel();
            } else if (typeof cancellable === "number") {
                Timer.clearInterval(cancellable);
                Timer.clearTimeout(cancellable);
            }
        }
        return cancelled;
    }

    public clear(): void {
        this.group = [];
    }
}
